import{__require as r}from"./is-object.js";var e,n;function t(){if(n)return e;n=1;var t=r();return e=function(r){return t(r)||null===r}}export{t as __require};
//# sourceMappingURL=is-possible-prototype.js.map
